import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="text-light py-4 mt-5">
      <Container>
        <Row className="gy-4">
          <Col xs={12} sm={6} md={4} className="mb-3 mb-md-0">
            <h5 className="mb-3">BattleZoneArena</h5>
            <p className="text-muted">
              Join exciting tournaments for PUBG, Free Fire, and other multiplayer games.
            </p>
          </Col>
          <Col xs={12} sm={6} md={4} className="mb-3 mb-md-0">
            <h5 className="mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="/" className="text-light">Home</a></li>
              <li className="mb-2"><a href="/tournaments" className="text-light">Tournaments</a></li>
              <li className="mb-2"><a href="/login" className="text-light">Login</a></li>
              <li className="mb-2"><a href="/signup" className="text-light">Sign Up</a></li>
            </ul>
          </Col>
          <Col xs={12} sm={12} md={4}>
            <h5 className="mb-3">Contact Us</h5>
            <p className="text-muted">
              Email: battlezonearena398@gmail.com
            </p>
            <p className="text-muted mb-2">
              Join WhatsApp group for PUBG announcements:<br />
              <a 
                href="https://chat.whatsapp.com/IiBXpGYmhQm6s0kI7mEfVD" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-light"
              >
                https://chat.whatsapp.com/IiBXpGYmhQm6s0kI7mEfVD
              </a>
            </p>
            <p className="text-muted">
              Join WhatsApp group for Free Fire announcements:<br />
              <a 
                href="https://chat.whatsapp.com/InEuN9DrYHwEke6UN7Uz4S" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-light"
              >
                https://chat.whatsapp.com/InEuN9DrYHwEke6UN7Uz4S
              </a>
            </p>
          </Col>
        </Row>
        <hr className="my-3 bg-secondary" />
        <Row>
          <Col className="text-center">
            <p className="mb-0 text-muted small">
              &copy; {new Date().getFullYear()} BattleZoneArena. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
